<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file tileCardTicket.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  tileCardTicket.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div v-if="hasTicket" :id="`ticket-selection--${ticket.id}`" data-ref="tile-card--ticket">
        <div class="py-1 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <div v-if="ticket_icon.material === true"
                     :style="'padding:0.3rem;background-color:' + ticket_icon.bg"
                     class="text-center mr-2"
                >
                    <i class="material-icons fs-10 text-white">
                        {{ticket_icon.data}}
                    </i>
                </div>
                <i v-else
                   :style="'padding:0.3rem;'"
                   :class="ticket.icon"
                   class="mr-2 fs-10 text-primary"/>
                <InfoButton @click="toggleTicket()"
                            :active="ticket.show"/>
            </div>
            <span class="text-uppercase">{{ticket.title}}</span>
            <!--                            show the buy button-->
           <div data-ref="buttons">
               <button data-ref="buy_button" v-if="!ticket.sold_out"
                       v-on:click="ticketClicked(ticket.id)"
                       class="test btn d-flex justify-content-center align-items-center btn-info btn--with-icon m-0 position-relative btn-primary"
               >
                   <i aria-hidden="true"
                      class="material-icons"
                   >add_shopping_cart</i>
                   <!---->
                   <span data-element="button-price-wrapper">
                                <span class="text-body fs-7 lh-7"><span
                                        class="money--currency_code money--currency_code"
                                >£</span><span
                                        class="money--currency_number money--currency_number"
                                >{{formatTicketPrice}}</span></span>
                            </span>
               </button>
               <button v-else
                       class="btn d-flex justify-content-center align-items-center btn-outline-primary disabled btn--with-icon">
                   <i aria-hidden="true"
                      class="material-icons">not_interested</i> <span
                       class="text-body fs-4">sold out</span>
               </button>
           </div>
        </div>

        <transition name="fade">
            <template v-if="ticket.show">
                <TicketInfo
                        :info_full_width="info_full_width"
                        :ticket="ticket"
                />
            </template>
        </transition>
    </div>
</template>

<script>
    window.Vue.component('TicketInfo', require('../../tickets/TicketInfo'));

    export default {
        name: "tileCardTicket",
        props: {
            info_full_width:{
                type:Boolean,
                default:true
            },
            ticket: {
                type: Object
            },
            index: {
                type: Number
            },
            tickets_len: {
                type: Number,
                default: null
            },
            first: {
                type: Boolean,
                default: false
            },
            tickets_limit: {
                type: Number,
                default: 6
            }
        },
        mounted() {
            let self = this;
            self.$nextTick(function () {
                let testIcon = self.ticketIcon();

                if (testIcon !== null) {
                    self.ticket_icon.material = testIcon.material;
                    self.ticket_icon.data = testIcon.data;
                    self.ticket_icon.bg = testIcon.bg;
                }
            });
            if (self.tickets_len !== null && (self.tickets_len <= self.tickets_limit && self.first)) {
              // Candice wanted all tickets to be collapsed, see HD ticket HELP-77
              //self.toggleTicket();
            }
        },
        data() {
            return {
                ticket_icon: {
                    material: false,
                    data: null,
                    bg: null
                }
            }
        },
        methods: {
            ticketClicked(id) {
                this.$emit('ticket_clicked', id)
            },
            toggleTicket() {
                let self = this;

                this.$emit('toggle', self.index)
            },
            ticketIcon() {
                let self = this;
                // check attributes
                if (typeof self.ticket.attributes !== 'undefined' && self.ticket.attributes !== null) {
                    for (let i = 0; i < self.ticket.attributes.length; i++) {
                        let attribute = self.ticket.attributes[i];
                        if (attribute.slug === 'blue-badge') {
                            return {
                                data: 'accessible',
                                material: true,
                                bg: '#5162ff'
                            }
                        }
                    }
                }
                return null;
            },
        },
        computed:{
            formatTicketPrice(){
                let price = this.ticket.price;
                return price.toFixed(2);
            },
            hasTicket(){
                return !(typeof this.ticket == 'undefined')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/modules/tileCardTicket.vue